import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

const HomeButton = () => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Tooltip title="HOME">
            <div
                style={{
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '50%',
                    backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onClick={() => navigate('/home')}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <HomeIcon />
            </div>
        </Tooltip>
    );
};

export default HomeButton;
